import { get } from "lodash";
import { Component } from "react";
import { connect } from "react-redux";
import type {
  EventMarketType,
  EventRunnerType,
  EventType,
  MarketType,
} from "../../../../../../../../../../../types/eventType";
import Runner from "../Runner/Runner";
import "./MarketRunnerDetailsBySequence.scss";

type Props = {
  event: EventType;
  market: EventMarketType;
  marketType: MarketType;
  addBetSlip: (...args: Array<any>) => any;
  numerOfRows: number;
};

// return a component with runners grouped by sequence number into rows
// EG 2 rows will have runners arragged as follows:
//  seq num 1 3 5 7
//          2 4 6 8

class MarketRunnerDetailsBySequence extends Component<Props> {
  renderGroups() {
    const { event, marketType, numerOfRows, market } = this.props;
    const groups: JSX.Element[] = [];
    const runners = get(market, ["runners"]);

    if (runners && runners.length > 0) {
      const runnersLength = (runners && runners.length) || 0;
      for (let i = 0; i < runnersLength; i += numerOfRows) {
        const group: EventRunnerType[] = runners.slice(i, i + numerOfRows);
        const groupedRunners = group.map((runner: EventRunnerType, index) => {
          const hasPrices =
            runner["aggregatedPrices"] && runner["aggregatedPrices"].length > 0
              ? true
              : false;
          if (!hasPrices) {
            return (
              <span
                key={"binary" + runner.id}
                className={"sequence-container__runner--empty"}
              ></span>
            );
          }
          return (
            runner && (
              <Runner
                runner={runner}
                index={runner.id}
                event={event}
                marketType={marketType}
                key={`sequence_${runner.id}_${index}`}
              />
            )
          );
        });
        const ele: JSX.Element = (
          <div className="sequence-container__group" key={`group_${i}`}>
            {groupedRunners}
          </div>
        );
        groups.push(ele);
      }
      return groups;
    } else {
      return groups;
    }
  }

  render() {
    const groups = this.renderGroups();
    return <div className="sequence-container">{groups}</div>;
  }
}

function mapDispatchToProps(dispatch) {
  return {
    addBetSlip: (betSlip: EventType) =>
      dispatch.betSlipListModel.addBetSlip(betSlip),
  };
}

export default connect(
  null,
  mapDispatchToProps
)(MarketRunnerDetailsBySequence) as any;
